import { SmButton } from '@smiles/smiles-react-design-system';
import React, { useEffect, useState } from 'react';

import useApi from '@/hooks/useApi';
import useEvent from '@/hooks/useEvent';

import Checkbox from '@/components/checkbox/Checkbox';

import { TModalContent } from '@/services/requests/Liferay/types';
import { TProductResponse } from '@/services/requests/ProductConfig/types';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { TInteractionType } from '@/services/requests/Interactions/types';

type TProps = {
  data: TModalContent;
  productData: TProductResponse;
  onClose: () => void;
};

export const ScreenDashboard = ({ data, productData, onClose }: TProps) => {
  const [selected, setSelected] = useState('');

  const { ApiInteractions, setTraceId } = useApi();
  const event = useEvent();

  const toggleSelect = (e: any) => {
    let type: TInteractionType = 'extra_cobranded_select_bb';
    if (e.target.id === 'santander') {
      type = 'extra_cobranded_select_santander';
    } else if (e.target.id === 'bradesco') {
      type = 'extra_cobranded_select_bradesco';
    }
    dispatchInteraction(ApiInteractions, type, {
      recommendationId: event.data.recommendationId,
    });
    setSelected(e.target.id);
  };

  const validateBankSelected = (obj: TProductResponse, assert: string) => {
    const resultKey =
      Object.keys(obj).find(key => key === assert) || Object.keys(obj)[0];

    return resultKey as keyof TProductResponse;
  };

  const handleSubmit = async () => {
    const key = validateBankSelected(productData, selected);

    await dispatchInteraction(ApiInteractions, 'extra_cobranded_click_cta', {
      recommendationId: event.data.recommendationId,
      details: { bank: key },
    });
    window.location.href = productData[key].keyConfigApi
      ? productData[key].linkRedirectConfigApi
      : productData[key].linkRedirect;
  };

  const handleClose = () => {
    dispatchInteraction(ApiInteractions, 'extra_cobranded_click_close', {
      recommendationId: event.data.recommendationId,
    });
    onClose();
  };

  useEffect(() => {
    setTraceId(event.data.traceId);
  }, [event, setTraceId]);

  return (
    <div className="smls-bank-card-modals__modal" data-testid="modal-content">
      <div className="smls-bank-card-modals__content">
        <div className="smls-bank-card-modals__button--close">
          <SmButton
            onClick={handleClose}
            isPill
            isOutlined
            icon={<span className="material-icons">close</span>}
          />
        </div>

        <div
          className="smls-bank-card-modals__modal--title"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: data.modalTitle }}
        />
        <div
          className="smls-bank-card-modals__modal--description"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: data.modalDescription }}
        />
        <div className="smls-bank-card-modals__modal--partners">
          <ul className="smls-bank-card-modals__modal--bank-list">
            {data.banks.map(bankContent => (
              <Checkbox
                key={bankContent.name}
                id={bankContent.name.trim().toLocaleLowerCase()}
                checked={
                  selected === bankContent.name.trim().toLocaleLowerCase()
                }
                onClick={toggleSelect}
                label="form_check_first_label"
                labelText="form_check_second_label"
                media={bankContent.image}
              />
            ))}
          </ul>
        </div>
        <div className="smls-bank-card-modals__modal--cta">
          <SmButton
            onClick={handleSubmit}
            text={data.modalCtaLabel}
            disabled={!selected}
          />
        </div>
      </div>
    </div>
  );
};
